import React from 'react'
import './AboutCover.css'

const AboutCover = () => {
  return (
    <div className='about-cover-container'>
        <div className="hl-0"></div>
        <div className="hl-1"></div>
        <div className="hl-2"></div>
        <div className="hl-3"></div>
        <div className="about-company" style={{'color':'#000', 'width':'230px'}}>Chawla<br/> Structural <br/> Design <br/> Engineers <br/> & <br/> Consultant</div>
      <div className="about-text">ABOUT<br/>CHAWLA<br/> STRUCTURAL DESIGN ENGINEERS & CONSULTANT</div>
    </div>
  )
}

export default AboutCover
